"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncSubscribeMessageTemplate = syncSubscribeMessageTemplate;
exports.templatemessageCreateApi = templatemessageCreateApi;
exports.templatemessageDeleteApi = templatemessageDeleteApi;
exports.templatemessageDetailApi = templatemessageDetailApi;
exports.templatemessageListApi = templatemessageListApi;
exports.templatemessageUpdateApi = templatemessageUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function templatemessageCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/templateMessage/save',
    method: 'POST',
    data: data
  });
}
function templatemessageUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/templateMessage/update',
    method: 'POST',
    data: data
  });
}
function templatemessageDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/templateMessage/info/".concat(id),
    method: 'GET'
  });
}
function templatemessageDeleteApi(data) {
  return (0, _request.default)({
    url: "/admin/templateMessage/delete",
    method: 'get',
    params: data // 接收对象参数
  });
}
function syncSubscribeMessageTemplate(tenantId) {
  return (0, _request.default)({
    url: "/admin/templateMessage/syncSubscribeMessageTemplate/".concat(tenantId),
    method: 'GET'
  });
}
function templatemessageListApi(params) {
  return (0, _request.default)({
    url: '/admin/templateMessage/list',
    method: 'GET',
    params: params
  });
}